/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PassPaymentStatus {
  PENDING_PAYMENT = 'pending_payment',
  PAID = 'paid',
  CONFIRMED = 'confirmed',
  MANUAL = 'manual',
}
